import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import t from "../button/button.js";
import n from "../stack/stack.js";
import r from "../tooltip/tooltip.js";
import i from "../keyboard-shortcut/keyboard-shortcut.js";
import { createBlock as a, createCommentVNode as o, createElementVNode as s, createVNode as c, openBlock as l, renderSlot as u, resolveComponent as d, toDisplayString as f, withCtx as p } from "vue";
//#region recipes/conversation_view/message_input/message_input_button.vue
var m = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeMessageInputButton",
	components: {
		DtButton: t,
		DtTooltip: r,
		DtStack: n,
		DtKeyboardShortcut: i
	},
	props: {
		ariaLabel: {
			type: String,
			required: !0
		},
		tooltipText: {
			type: String,
			required: !0
		},
		keyboardShortcutText: {
			type: String,
			default: ""
		},
		isActive: {
			type: Boolean,
			default: !1
		},
		dataQa: {
			type: String,
			required: !0
		}
	},
	emits: ["click"]
};
function h(e, t, n, r, i, m) {
	let h = d("dt-button"), g = d("dt-keyboard-shortcut"), _ = d("dt-stack"), v = d("dt-tooltip");
	return l(), a(v, null, {
		anchor: p(() => [c(h, {
			"data-qa": n.dataQa,
			importance: "clear",
			kind: "muted",
			"aria-label": n.ariaLabel,
			size: 100,
			active: n.isActive,
			onClick: t[0] || (t[0] = (t) => e.$emit("click", t))
		}, {
			icon: p(() => [u(e.$slots, "icon")]),
			_: 3
		}, 8, [
			"data-qa",
			"aria-label",
			"active"
		])]),
		default: p(() => [c(_, { gap: "200" }, {
			default: p(() => [s("p", null, f(n.tooltipText), 1), n.keyboardShortcutText ? (l(), a(g, {
				key: 0,
				inverted: "",
				shortcut: n.keyboardShortcutText
			}, null, 8, ["shortcut"])) : o("", !0)]),
			_: 1
		})]),
		_: 3
	});
}
var g = /* @__PURE__ */ e(m, [["render", h]]);
//#endregion
export { g as default };

//# sourceMappingURL=message-input-button.js.map